import React, { useState, useEffect } from 'react';
import styles from '../styles/AddSupplierModal.module.css';
import CustomSelect from '../customComponents/CustomSelect';
import { API_URL } from '../config/api';


const AddSupplierModal = ({ onClose, onSupplierAdded }) => {
  const [form, setForm] = useState({
    sn: '',
    org_type: 'individual',
    name: '',
    phone: '',
    city: '',
    address: '',
  });

  const [snError, setSnError] = useState('');
  const [serverError, setServerError] = useState(''); 
  const [showError, setShowError] = useState(false);

  const options = [
    { label: 'ИП', value: 'individual' },
    { label: 'ТОО', value: 'llp' },
    { label: 'АО', value: 'jsc' },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'sn' && value.length <= 12) setSnError('');
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const snRegex = /^\d{12}$/;
    if (!snRegex.test(form.sn)) {
      setSnError('ИИН/БИН должен содержать ровно 12 цифр');
      return;
    }

    try {
      const payload = { ...form, type: 'supplier' };
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/contractors`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        // Проверяем, есть ли message или массив ошибок
        const message = errorData.message 
          || (errorData.errors && Object.values(errorData.errors).flat().join(', ')) 
          || 'Ошибка при добавлении поставщика';
        throw new Error(message);
      }

      onSupplierAdded();
      onClose();
    } catch (err) {
      setServerError(err.message || 'Не удалось добавить поставщика');
      setShowError(true);
    }
  };

  // Автоскрытие ошибки через 3 сек
  useEffect(() => {
    if (showError) {
      const timer = setTimeout(() => setShowError(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showError]);

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.headText}>Добавить поставщика</h2>

        <input
          name="sn"
          value={form.sn}
          onChange={handleChange}
          placeholder="ИИН / БИН"
          className={snError ? styles.inputError : ''}
        />
        {snError && <div className={styles.error}>{snError}</div>}

        <CustomSelect
          className={styles.filters__select}
          options={options}
          value={form.org_type}
          onChange={(val) => setForm((prev) => ({ ...prev, org_type: val }))}
          placeholder="Тип компании"
        />

        <input name="name" value={form.name} onChange={handleChange} placeholder="Название компании" />
        <input name="phone" value={form.phone} onChange={handleChange} placeholder="+7 (999) - 999 - 99 - 99" />
        <input name="city" value={form.city} onChange={handleChange} placeholder="Город" />
        <input name="address" value={form.address} onChange={handleChange} placeholder="Адрес" />

        <div className={styles.actions}>
          <button className={styles.cancel} onClick={onClose}>Отмена</button>
          <button className={styles.save} onClick={handleSubmit}>Сохранить</button>
        </div>

        {showError && (
          <div className={styles.serverError}>
            {serverError}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddSupplierModal;
